import { Discount } from '../models/serializable/discounts/discount.js';
import { BusinessPromoCode } from '../models/serializable/discounts/business-promo-code.js';
import { Price } from '../models/serializable/price.js';
import { isNotNullOrUndefined } from '../utility/null-safety.js';
import { DiscountModifier, DiscountProvider } from './discount-provider.js';
import { DiscountFactory } from '../factories/discount-factory.js';

export class BusinessPromoCodeDiscountProvider extends DiscountProvider {
  private uses: number;

  constructor(private readonly promoCode: BusinessPromoCode) {
    super();
    this.uses = this.promoCode.uses ?? 0;
  }

  findDiscountForSingleTicket(ticketId: string): Discount | null {
    if(this.promoCode.maxUses != null && this.uses >= this.promoCode.maxUses) {
      return null;
    }

    return this._findDiscountForSingleTicket();
  }

  findDiscountForMultipleTickets(ticketId: string, quantity: number): DiscountModifier | null {
    if(this.promoCode.maxUses != null && this.uses >= this.promoCode.maxUses) {
      return null;
    }

    if(isNotNullOrUndefined(quantity) && quantity > 1) {
      return this._findDiscountForMultipleTickets(quantity, this.promoCode.maxUses);
    }
    else {
      const discount = this._findDiscountForSingleTicket();
      return { discount, availableUses: 1 };
    }
  }

  findDiscountForOrder(orderPrice: Price): Discount | null {
    return null;
  }

  reset(): void {
    this.uses = this.promoCode.uses ?? 0;
  }

  private _findDiscountForSingleTicket(): Discount {
    this.uses++;
    return DiscountFactory.fromBusinessPromoCode(this.promoCode);
  }

  private _findDiscountForMultipleTickets(quantity: number, maxUses: number | null): DiscountModifier {
    const discount = DiscountFactory.fromBusinessPromoCode(this.promoCode);
    const availableUses = (maxUses == null) ? quantity : Math.min(quantity, maxUses - this.uses);

    this.uses += availableUses;

    return { discount, availableUses };
  }
}
